import React, {useEffect} from 'react';
import {Routes, Route, useLocation} from 'react-router-dom';
import './App.css';

import Layout from '../src/components/Layout';

import Home from './pages/Home';
import AboutMe from './pages/AboutMe';
import Books from './pages/Books';
import Contact from './pages/Contact';
import Events from './pages/Events';
import LinkInBio from './pages/LinkInBio';
import News from './pages/News';
import Newsletter from './pages/Newsletter';
import Reviews from './pages/Reviews';
import WritingTips from './pages/WritingTips';
import Error from './pages/Error';

export default function App() {
  const location = useLocation();

  useEffect(() => {
    window.scrollTo(0, 0);
  }, [location]);

  return (
    <div className='App'>
      <Layout>
        <Routes>
          <Route
            path='/'
            element={<Home />}
          />
          <Route
            path='/aboutme'
            element={<AboutMe />}
          />
          <Route
            path='/books'
            element={<Books />}
          />
          <Route
            path='/contact'
            element={<Contact />}
          />
          <Route
            path='/newsletter'
            element={<Newsletter />}
          />
          <Route
            path='/reviews'
            element={<Reviews />}
          />
          <Route
            path='/writingtips'
            element={<WritingTips />}
          />
          <Route
            path='/events'
            element={<Events />}
          />
          <Route
            path='/news'
            element={<News />}
          />
          <Route
            path='/linkinbio'
            element={<LinkInBio />}
          />
          <Route
            path='*'
            element={<Error />}
          />
        </Routes>
      </Layout>
    </div>
  );
}
